export type RequestCardPressAction = 'open' | 'toggle' | 'ignore';

/**
 * Gmail-style mobile card press:
 * - after a long press, the synthesized click / `onAction` is ignored
 * - tap toggles while at least one request is selected
 * - tap opens the request when the selection is empty
 */
export const resolveRequestCardPress = ({
  isSelectionActive,
  isLongPressSuppressed,
}: {
  isSelectionActive: boolean;
  isLongPressSuppressed: boolean;
}): RequestCardPressAction => {
  if (isLongPressSuppressed) {
    return 'ignore';
  }

  return isSelectionActive ? 'toggle' : 'open';
};
